import { Component, inject } from "@angular/core";
import { DialogService } from "./dialog.service";
import { AsyncPipe } from "@angular/common";
import { SelectEventLocationDialogComponent } from "../select-event-location-dialog/select-event-location-dialog.component";
import { ConfirmDialogComponent } from "../confirm-dialog/confirm-dialog.component";
import { AlertDialogComponent } from "../alert-dialog/alert-dialog.component";
import { LogService } from "../../service/logging/log.service";
import { SelectOneRadioComponent } from "../select-one-radio/select-one-radio.component";

@Component({
    selector: 'app-dialog-host',
    templateUrl: './dialog-host.component.html',
    standalone: true,
    imports: [AlertDialogComponent, ConfirmDialogComponent, SelectEventLocationDialogComponent, AsyncPipe, SelectOneRadioComponent],
})
export class DialogHostComponent {
  logger = inject(LogService);
  service = inject(DialogService);

  constructor () {
    this.logger.debug("dialog-service instance: ", this.service)
  }
}
